import { axios, API, SendRequest} from '@/imports-files/components/model/custom-company-integration-modal.js';
         

export class CustomCompanyIntegrationModalService extends SendRequest
{
    async addCustomIntegrationsList(params)
    {
        const url = API.client.activities.CUSTOM_INTEGRATIONS;
        try
        {
        const result = await axios.post( url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
        } 
        catch (error) 
        {
        return error;
        }
    }


    async updateCustomIntegrationsList(params)
    {
        const url = API.client.activities.UPDATE_CUSTOM_INTEGRATIONS.replace('$integration_id', params.custom_integration.id );
        try 
            {
                const result = await axios.put(url,
                params,
                this.setHeaderJSON(),
                this.setCrossDomainTrue(),
                this.setCredentialsJSON());
                return result;
            } 
            catch (error) 
            {
            return error;
            }
        }
}
